import axios from '@/axios'
const BASE_URL = '/api/community/public'
const api = {
  form_json: `${BASE_URL}/superform/form`,
  add_form: `${BASE_URL}/superform/submitform`
}

export const AuthorService = {
  getForm(data) {
    return axios.get(api.form_json, { params: data }).then(res => {
      return Promise.resolve(res.data)
    })
  },
  addForm(data) {
    return axios.post(api.add_form, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
}
export default AuthorService